import React from 'react'
import { Row, Col } from 'antd';
import styled from 'styled-components'
import { useTranslation } from 'react-i18next';

export default function About() {

    const { t } = useTranslation()

    return (
        <>
            <Row align='center' justify='center' style={{padding: '60px 0 0 0', width: '100%'}}>
                <Col xs={20} sm={20} md={10} lg={7} xl={4}>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                        <Img src='https://lpgoulart.github.io/assets/me.jpg' width='100%' alt='me' />
                    </div>
                </Col>
                <Col xs={22} sm={22} md={18} lg={14} xl={14}>
                    <Aboutme>
                        <Paragraph>
                            {t('aboutme')}
                        </Paragraph>
                    </Aboutme>
                </Col>
            </Row>

        </>
    )
}


const Img = styled.img`
    border-radius: 100%
`

const Aboutme = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%
`

const Paragraph = styled.p`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    font-size: 16px;
    color: black!important;
    height:100%;
`